/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SetCompanyFeatureRequest = {
    type: 'one-of',
    contains: [],
};